/**
 * Hook: fetch unread counts for the 3 Polaroid catalogs (gifts/market/lessons)
 * for the currently authenticated community member.
 */
import { useEffect, useState } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const CATEGORIES = ['gifts', 'market', 'lessons'];

export const usePolaroidUnread = (community, getToken) => {
  const [counts, setCounts] = useState({ gifts: 0, market: 0, lessons: 0 });

  useEffect(() => {
    const token = getToken && getToken();
    if (!token) return;
    let cancelled = false;
    Promise.all(
      CATEGORIES.map((c) =>
        axios
          .get(`${API_URL}/api/polaroid/${c}/unread-count`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((r) => [c, r.data?.unread || 0])
          .catch(() => [c, 0])
      )
    ).then((pairs) => {
      if (cancelled) return;
      const next = Object.fromEntries(pairs);
      setCounts((prev) => ({ ...prev, ...next }));
    });
    return () => { cancelled = true; };
  }, [community, getToken]);

  return counts;
};
